import Need from "../Need";

export const NeedLicenseView = new Need('license.view');
